module.exports = __webpack_public_path__ + "img/overview-email-icon.svg";